import { render } from "./CardProject.vue?vue&type=template&id=4df1b25e"
import script from "./CardProject.vue?vue&type=script&lang=js"
export * from "./CardProject.vue?vue&type=script&lang=js"

import "./CardProject.vue?vue&type=style&index=0&id=4df1b25e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__